import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	lista: [],
	listaUnidade: [],
	listaItem: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ACESSORIO_INVENTARIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'ACESSORIO_INVENTARIO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'ACESSORIO_INVENTARIO_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'ACESSORIO_INVENTARIO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
			
        case 'ACESSORIO_INVENTARIO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

		case 'ACESSORIO_INVENTARIO_ITEM_LISTADO':
            return {
				...state,
				listaItem: action.payload.data
			};

        default:
            return state;
    }
}
